import { render, staticRenderFns } from "./ByRegion.vue?vue&type=template&id=4fd61137&lang=pug&"
import script from "./ByRegion.vue?vue&type=script&lang=js&"
export * from "./ByRegion.vue?vue&type=script&lang=js&"
import style0 from "./ByRegion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports